export const getCookie = key => { 
    var cookie = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)'); 
    return cookie ? cookie.pop() : ''; 
}

export const setCookie = (name, value, days) => {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}